import { render } from "./ProfilePicture.vue?vue&type=template&id=4febd1f8&scoped=true"
import script from "./ProfilePicture.vue?vue&type=script&lang=js"
export * from "./ProfilePicture.vue?vue&type=script&lang=js"

import "./ProfilePicture.vue?vue&type=style&index=0&id=4febd1f8&lang=scss&scoped=true"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4febd1f8"]])

export default __exports__